interface WorkerMessage {
  action: "start" | "pause";
  hours: number;
  minutes: number;
  seconds: number;
}

const workerCode = () => {
  let timerId: any;
  let tempMinutes: number;
  let tempSeconds: number;
  let tempHours: number;

  onmessage = (e: MessageEvent<WorkerMessage>) => {
    const { hours, minutes, seconds, action } = e.data;
    tempMinutes = minutes;
    tempSeconds = seconds;
    tempHours = hours;

    switch (action) {
      case "start":
        if (!timerId) {
          timerId = setInterval(() => {
            if (tempSeconds === 0 && tempMinutes === 0 && tempHours === 0) {
              clearInterval(timerId);
              timerId = null;
              postMessage({ minutes: 0, seconds: 0, hours: 0 });
            } else if (tempSeconds === 0 && tempMinutes > 0 && tempHours > 0) {
              postMessage({
                minutes: tempMinutes - 1,
                seconds: 59,
                hours: tempHours,
              });
              tempMinutes = tempMinutes - 1;
              tempSeconds = 59;
            } else if (
              tempSeconds === 0 &&
              tempMinutes === 0 &&
              tempHours > 0
            ) {
              postMessage({
                minutes: 59,
                seconds: 59,
                hours: tempHours - 1,
              });
              tempHours = tempHours - 1;
              tempMinutes = 59;
              tempSeconds = 59;
            } else if (
              tempSeconds === 0 &&
              tempMinutes > 0 &&
              tempHours === 0
            ) {
              postMessage({
                minutes: tempMinutes - 1,
                seconds: 59,
                hours: tempHours,
              });
              tempMinutes = tempMinutes - 1;
              tempSeconds = 59;
            } else {
              postMessage({
                minutes: tempMinutes,
                seconds: tempSeconds - 1,
                hours: tempHours,
              });
              tempSeconds = tempSeconds - 1;
            }
          }, 1000);
        }
        break;
      case "pause":
        if (timerId !== null) {
          clearInterval(timerId);
          timerId = null;
        }
        break;

      default:
        break;
    }
  };
};

let code = workerCode.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));

const blob = new Blob([code], { type: "application/javascript" });
const worker_script = URL.createObjectURL(blob);
export const counter = new Worker(worker_script);
